/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Preset_TodayInputs */

const vi_warehouse_sales_preset_today = /** @type {(inputs: Warehouse_Sales_Preset_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hôm nay`)
};

/**

* @param {Warehouse_Sales_Preset_TodayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_preset_today = /** @type {((inputs?: Warehouse_Sales_Preset_TodayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Preset_TodayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_preset_today(inputs)
});